/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCoinResponse
 */
export interface UpdateCoinResponse {
    /**
     * Indicates if the update was successful
     * @type {boolean}
     * @memberof UpdateCoinResponse
     */
    success?: boolean;
}

/**
 * Check if a given object implements the UpdateCoinResponse interface.
 */
export function instanceOfUpdateCoinResponse(value: object): value is UpdateCoinResponse {
    let isInstance = true;

    return isInstance;
}

export function UpdateCoinResponseFromJSON(json: any): UpdateCoinResponse {
    return UpdateCoinResponseFromJSONTyped(json, false);
}

export function UpdateCoinResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCoinResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': !exists(json, 'success') ? undefined : json['success'],
    };
}

export function UpdateCoinResponseToJSON(value?: UpdateCoinResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
    };
}

